import ApiClient from './ApiClient';

class AccountScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new AccountScheduledMessagesAPI();
